import React from 'react';

import {map} from 'lodash';
import qs from 'query-string';
import {DialogResult, DialogTypes} from 'common/names';

import {layoutActions} from '../redux';
import ArchiveSettingsDialog from './dialogs/settings/ArchiveSettingsDialog';
import AuditReportDialog from './dialogs/reports/AuditReportDialog';
import CalendarsDialog from './dialogs/Calendars';
import ITSupportEmailSettingsDialog from './dialogs/settings/ITSupportEmailSettingsDialog';
import JobQueueSettingsDialog from './dialogs/settings/JobQueueSettingsDialog';
import LogSettingsDialog from './dialogs/settings/LogSettingsDialog';
import ProxiesDialog from './dialogs/proxies/ProxiesDialog';
import SearchPartnerDialog from 'features/layout/DialogRoutes/dialogs/partners/SearchPartnerDialog';
import SessionDataDialog from './dialogs/settings/SessionDataDialog';
import UserAccountSettingDialog from './dialogs/UserAdmins/UserAccountSettingDialog';

import BackupSettingsDialog from './dialogs/settings/BackupSettingsDialog';

import SettingsEmailDialog from './dialogs/settings/SettingsEmailDialog';
import SettingsFTPDialog from './dialogs/settings/SettingsFTPDialog';
import SettingsJobMonitorDialog from './dialogs/settings/SettingsJobMonitorDialog';
import SettingsOpenPGPKeys from './dialogs/settings/SettingsOpenPGPKeys';
import SettingsPagingDialog from './dialogs/settings/SettingsPagingDialog';
import {ConfirmationDialog} from 'components/dialogs/ConfirmationDialog';
import {IDialogProps} from '../redux/types';
import {AlertDialog} from 'components/dialogs/AlertDialog';
import SystemStatusDialog from './dialogs/SystemStatusDialog';
import ImportSSLCertificateDialog from 'features/layout/DialogRoutes/dialogs/keys/ImportSSLCertificateDialog';
import CreateOpenPGPKeyPairDialog from './dialogs/keys/CreateOpenPGPKeyPairDialog';
import FolderAddDialog from './dialogs/folders/FolderAddDialog';
import RenameFolderDialog from 'features/layout/DialogRoutes/dialogs/folders/RenameFolderDialog';
import FolderDeleteDialog from './dialogs/folders/FolderDeleteDialog';
import SettingsAuditTrailDialog from './dialogs/settings/SettingsAuditTrailDialog';
import CreateSSHKeyDialog from './dialogs/keys/CreateSSHKeyDialog';
import {HelpAboutDialog} from './dialogs/HelpAboutDialog';
import {FileLicenseDialog} from './dialogs/FileLicenseDialog';
import {AuditSuspensionDialog} from './dialogs/settings/AuditSuspensionDialog';
import AuditWarningDialog from './dialogs/settings/AuditWarningDialog';
import {DiplomatObjectType} from 'types/DiplomatObjectType';
import SearchOpenPGPKeysDialog from 'features/layout/DialogRoutes/dialogs/keys/SearchOpenPGPKeysDialog';
import MoveFolderDialog from 'features/layout/DialogRoutes/dialogs/folders/MoveFolderDialog';
import DeleteSSLCertificateDialog from 'features/layout/DialogRoutes/dialogs/keys/DeleteSSLCertificateDialog';
import CreatePartnerDialog from 'features/layout/DialogRoutes/dialogs/partners/CreatePartnerDialog';
import RenameKeyDialog from 'features/layout/DialogRoutes/dialogs/keys/RenameKeyDialog';
import MoveKeysDialog from 'features/layout/DialogRoutes/dialogs/keys/MoveKeysDialog';
import SearchSSLKeysDialog from 'features/layout/DialogRoutes/dialogs/keys/SearchSSLKeysDialog';
import DeletePGPKeyDialog from 'features/layout/DialogRoutes/dialogs/keys/DeletePGPKeyDialog';
import SearchSSHClientKeysDialog from 'features/layout/DialogRoutes/dialogs/keys/SearchSSHClientKeysDialog';
import SearchTransactionDialog from 'features/layout/DialogRoutes/dialogs/transactions/SearchTransactionDialog';
import OpenPgpSubKeyCreation from 'features/layout/DialogRoutes/dialogs/keys/OpenPGPSubKeyCreation';
import RenamePartnerDialog from './dialogs/partners/RenamePartnerDialog';
import MovePartnerDialog from './dialogs/partners/MovePartnerDialog';
import DeletePartnerDialog from './dialogs/partners/DeletePartnerDialog';
import SaveAsPartnerDialog from './dialogs/partners/SaveAsPartnerDialog';
import SaveTransactionAsDialog from './dialogs/transactions/SaveTransactionAsDialog';
import RenameTransactionDialog from './dialogs/transactions/RenameTransactionDialog';
import DeleteTransactionDialog from './dialogs/transactions/DeleteTransactionDialog';
import MoveTransactionDialog from './dialogs/transactions/MoveTransactionDialog';
import {RunNowDialog} from '../CommonPage/panels/TransactionPanel/SchedulePanel/RunNow/RunNowDialog';
import {LogViewerLastStartEndDialog} from './dialogs/logs/LogViewerLastStartEndDialog';
import {LogsDialog} from './dialogs/logs/LogsDialog';
import BackupDialog from './dialogs/file-menu/BackupDialog';
import {IAbstractDialog} from './dialogs/types';
import InputDialog from 'components/dialogs/InputDialog';
import FileManagerDialogWrapper from './dialogs/FileManagerDialog/FileManagerDialogWrapper';
import {CancelableConfirmationDialog} from 'components/dialogs/CancelableConfirmationDialog';
import StatusDialog from 'components/dialogs/StatusDialog';
import PendingChangesDialog from './dialogs/PendingChangesDialog';
import {ConfirmDialog} from 'components/dialogs/ConfirmDialog';
import TroubleShootingDialog from './dialogs/TroubleShootingDialog';
import ChangePasswordDialog from 'features/login/ChangePasswordDialog';
import CreateTransactionDialog from './dialogs/transactions/CreateTransactionDialog';
import ImportSshKeyPair from './dialogs/keys/ImportSSHKeyPair';
import DeleteSSHKeyPairDialog from 'features/layout/DialogRoutes/dialogs/keys/DeleteSSHKeyPairDialog';
import SshHostKeysDialog from 'features/layout/DialogRoutes/dialogs/keys/SshHostKeysDialog';
import {
   RecoverOpenPgpPublicKeysDialog,
   RecoverOpenPgpKeyPairsDialog,
} from 'features/layout/DialogRoutes/dialogs/keys/RecoverOpenPGPKeysDialog';
import {
   RecoverSSHPublicKeysDialog,
   RecoverSSHKeyPairsDialog,
} from 'features/layout/DialogRoutes/dialogs/keys/RecoverSSHClientKeysDialog';
import ImportOpenPGPKeysDialog from './dialogs/keys/ImportOpenPGPKeysDialog';
import SFTPServerSettingsDialog from '../CommonPage/panels/SFTP/SFTPServerSettingsPanel/SFTPServerSettingsDialog';
import CreateSftpUserDialog from './dialogs/sftp-users/CreateSftpUserDialog';
import RenameSftpUserDialog from './dialogs/sftp-users/RenameSftpUserDialog';
import DeleteSftpUserDialog from './dialogs/sftp-users/DeleteSftpUserDialog';
import MoveSftpUserDialog from './dialogs/sftp-users/MoveSftpUserDialog';
import ImportSSHPublicKey from './dialogs/keys/ImportSSHPublicKey';
import {UserActivityReportDialog} from './dialogs/reports/UserActivityReport';
import AuditSummaryReportDialog from './dialogs/reports/AuditSummaryReportDialog';
import ScheduledReports from './dialogs/reports/ScheduledReports';
import SearchSSHPublicKeysDialog from './dialogs/keys/SearchSSHPublicKeysDialog';
import {SFTPActivityReportDialog} from './dialogs/reports/SFTPActivityReportDialog';
import {SFTPConnectionsReportDialog} from './dialogs/reports/SFTPConnectionsReportDialog';
import RunNowFromTree from '../CommonPage/panels/TransactionPanel/SchedulePanel/RunNow/RunNowFromTree';
import CreateSynchronizationDialog from './dialogs/synchronizations/CreateSynchronizationDialog';
import SaveSynchronizationAsDialog from './dialogs/synchronizations/SaveSynchronizationAsDialog';
import DeleteSynchronizationDialog from 'features/layout/DialogRoutes/dialogs/synchronizations/DeleteSynchronizationDialog';
import SearchSynchronizationDialog from 'features/layout/DialogRoutes/dialogs/synchronizations/SearchSynchronizationDialog';
import MoveSynchronizationDialog from 'features/layout/DialogRoutes/dialogs/synchronizations/MoveSynchronizationDialog';
import SupportTicketDialog from 'features/layout/DialogRoutes/dialogs/SupportTicketDialog';
import CreateSftpGroupDialog from 'features/layout/DialogRoutes/dialogs/sftp-groups/CreateSftpGroupDialog';
import DeleteSftpGroupDialog from 'features/layout/DialogRoutes/dialogs/sftp-groups/DeleteSftpGroupDialog';
import RenameSftpGroupDialog from 'features/layout/DialogRoutes/dialogs/sftp-groups/RenameSftpGroupDialog';
import MoveSftpGroupDialog from 'features/layout/DialogRoutes/dialogs/sftp-groups/MoveSftpGroupDialog';
import DeleteVFSNodeDialog from 'features/layout/DialogRoutes/dialogs/vfs-nodes/DeleteVFSNodeDialog';
import CreatePhysicalFolderDialog from 'features/layout/DialogRoutes/dialogs/vfs-nodes/CreatePhysicalFolderDialog';
import CreateVirtualFolderDialog from 'features/layout/DialogRoutes/dialogs/vfs-nodes/CreateVirtualFolderDialog';
import LDAPSettingsDialog from 'features/layout/DialogRoutes/dialogs/settings/LDAPSettingsDialog';
import AddOpenPGPSubkeysDialog from './dialogs/keys/AddOpenPGPSubkeysDialog';
import {ReplaceKeyDialog} from './dialogs/keys/ReplaceKeyDialog';
import {CertDialog} from 'components/dialogs/CertDialog';
import {AuthenticatorSetupDialog} from 'features/login/AuthenticatorSetupDialog';
import {AuthenticatorVerifyDialog} from 'features/login/AuthenticatorVerifyDialog';
import {SelectDialog} from 'components/dialogs/SelectDialog';
import AdminRolesDialog from './dialogs/settings/AdminRolesDialog';
import {PermissionsDialog} from 'features/layout/DialogRoutes/dialogs/settings/PermissionsDialog';
import {RoiReportDialog} from 'features/roi/RoiReportDialog';
import SamlSettingsDialog from 'features/login/SamlSettingsDialog';
import {ThreatIntelligenceSettingsDialog} from './dialogs/settings/AdvancedThreatIntelligence';
import IPAccessRulesDialog from './dialogs/settings/AdvancedThreatIntelligence/IPAccessRulesDialog';
import {SftpIPAccessRulesDialog} from './dialogs/settings/AdvancedThreatIntelligence/SftpIPAccessRulesDialog';
import {Location} from 'react-router-dom';

export type CommonDialogProps = {
   closeDialog: typeof layoutActions.closeSubDialog;
   subDialogs: IDialogProps[];
};

type RouterInjectedProps = {
   navigate: ReturnType<typeof import('react-router-dom').useNavigate>;
   location: Location;
};

export type DialogRoutesProps = CommonDialogProps & RouterInjectedProps;

const dialogsMap: Record<string, (props: IAbstractDialog) => JSX.Element | null> = {
   [DialogTypes.SettingsSAMLDialog.id]: SamlSettingsDialog,
   [DialogTypes.AuthenticatorSetupDialog.id]: AuthenticatorSetupDialog,
   [DialogTypes.AuthenticatorVerifyDialog.id]: AuthenticatorVerifyDialog,
   [DialogTypes.AdminRolesDialog.id]: AdminRolesDialog,
   [DialogTypes.PermissionsDialog.id]: PermissionsDialog,
   [DialogTypes.CreateOpenPGPKeyPair.id]: CreateOpenPGPKeyPairDialog,
   [DialogTypes.OpenPGPSubKeyCreation.id]: OpenPgpSubKeyCreation,
   [DialogTypes.ImportOpenPGPKeysDialog.id]: ImportOpenPGPKeysDialog,
   [DialogTypes.ReplaceKey.id]: ReplaceKeyDialog,

   [DialogTypes.RenameKeyDialog.id]: RenameKeyDialog,
   [DialogTypes.RenamePartnerDialog.id]: RenamePartnerDialog,
   [DialogTypes.DeletePartnerDialog.id]: DeletePartnerDialog,
   [DialogTypes.SaveAsPartnerDialog.id]: SaveAsPartnerDialog,
   [DialogTypes.LogViewerLastStartEndDialog.id]: LogViewerLastStartEndDialog,
   [DialogTypes.FolderAddDialog.id]: FolderAddDialog,
   [DialogTypes.FolderRenameDialog.id]: RenameFolderDialog,
   [DialogTypes.FolderDeleteDialog.id]: FolderDeleteDialog,

   [DialogTypes.SaveTransactionAsDialog.id]: SaveTransactionAsDialog,
   [DialogTypes.RenameTransactionDialog.id]: RenameTransactionDialog,
   [DialogTypes.DeleteTransactionDialog.id]: DeleteTransactionDialog,
   [DialogTypes.RunNowTransactionDialog.id]: RunNowDialog,
   [DialogTypes.RunNowTransactionFromTreeDialog.id]: RunNowFromTree,
   [DialogTypes.MoveTransactionDialog.id]: MoveTransactionDialog,

   [DialogTypes.AddOpenPGPSubkeys.id]: AddOpenPGPSubkeysDialog,
   [DialogTypes.DeletePGPKeyDialog.id]: DeletePGPKeyDialog,
   [DialogTypes.RecoverOpenPgpPublicKeysDialog.id]: RecoverOpenPgpPublicKeysDialog,
   [DialogTypes.RecoverOpenPgpKeyPairsDialog.id]: RecoverOpenPgpKeyPairsDialog,
   [DialogTypes.ImportSSLServerCertificate.id]: ImportSSLCertificateDialog,
   [DialogTypes.DeleteSSLCertificateDialog.id]: DeleteSSLCertificateDialog,

   [DialogTypes.CreateSSHKeyPair.id]: CreateSSHKeyDialog,
   [DialogTypes.DeleteSSHKeyPairDialog.id]: DeleteSSHKeyPairDialog,
   [DialogTypes.RecoverSSHPublicKeysDialog.id]: RecoverSSHPublicKeysDialog,
   [DialogTypes.RecoverSSHKeyPairsDialog.id]: RecoverSSHKeyPairsDialog,

   [DialogTypes.ImportSSHKeyPair.id]: ImportSshKeyPair,
   [DialogTypes.ImportSSHPublic.id]: ImportSSHPublicKey,
   [DialogTypes.SshHostKeysDialog.id]: SshHostKeysDialog,
   [DialogTypes.BackupDialog.id]: BackupDialog,
   [DialogTypes.FileLicenseDialogBox.id]: FileLicenseDialog,
   [DialogTypes.HelpAboutBox.id]: HelpAboutDialog,
   [DialogTypes.SupportTicket.id]: SupportTicketDialog,
   [DialogTypes.SettingsFTPDialog.id]: SettingsFTPDialog,
   [DialogTypes.BackupSettingsDialog.id]: BackupSettingsDialog,
   [DialogTypes.SettingsOpenPGPKeys.id]: SettingsOpenPGPKeys,
   [DialogTypes.SettingsJobMonitorDialog.id]: SettingsJobMonitorDialog,
   [DialogTypes.JobQueueSettingsDialog.id]: JobQueueSettingsDialog,
   [DialogTypes.SettingsAuditTrailDialog.id]: SettingsAuditTrailDialog,
   [DialogTypes.AuditSuspensionDialog.id]: AuditSuspensionDialog,
   [DialogTypes.SettingsEmailDialog.id]: SettingsEmailDialog,
   [DialogTypes.SettingsPagingDialog.id]: SettingsPagingDialog,
   [DialogTypes.SettingsProxiesDialog.id]: ProxiesDialog,
   [DialogTypes.Calendars.id]: CalendarsDialog,
   [DialogTypes.SettingsPrimaryArchive.id]: ArchiveSettingsDialog,
   [DialogTypes.UserAccountSettingDialog.id]: UserAccountSettingDialog,
   [DialogTypes.ITSupportEmailSettingsDialog.id]: ITSupportEmailSettingsDialog,
   [DialogTypes.LogSettingsDialog.id]: LogSettingsDialog,
   [DialogTypes.SessionDataDialog.id]: SessionDataDialog,
   [DialogTypes.AuditReportDialog.id]: AuditReportDialog,
   [DialogTypes.AuditSummaryReportDialog.id]: AuditSummaryReportDialog,
   [DialogTypes.UserActivityReportDialog.id]: UserActivityReportDialog,
   [DialogTypes.SFTPActivityReportDialog.id]: SFTPActivityReportDialog,
   [DialogTypes.SFTPConnectionsReportDialog.id]: SFTPConnectionsReportDialog,
   [DialogTypes.ScheduledReports.id]: ScheduledReports,
   [DialogTypes.LogsDialog.id]: LogsDialog,
   [DialogTypes.SystemStatusDialog.id]: SystemStatusDialog,
   [DialogTypes.LDAPSettingsDialog.id]: LDAPSettingsDialog,
   [DialogTypes.RoiReportDialog.id]: RoiReportDialog,

   [DialogTypes.InputDialog.id]: InputDialog,
   [DialogTypes.SelectDialog.id]: SelectDialog,
   [DialogTypes.StatusDialog.id]: StatusDialog,
   [DialogTypes.FileManager.id]: FileManagerDialogWrapper,
   [DialogTypes.CertDialog.id]: CertDialog,
   // [DialogTypes.SFTPFileManager.id]: SFTPFileManagerDialog,
   [DialogTypes.PendingChangesDialog.id]: PendingChangesDialog,
   [DialogTypes.TroubleShootingDialog.id]: TroubleShootingDialog,
   [DialogTypes.ChangePasswordDialog.id]: ChangePasswordDialog,

   [DialogTypes.SFTPServerSettings.id]: SFTPServerSettingsDialog,
   [DialogTypes.ThreatIntelligenceSettings.id]: ThreatIntelligenceSettingsDialog,
   [DialogTypes.IPAccessRules.id]: IPAccessRulesDialog,
   [DialogTypes.SftpIPAccessRulesDialog.id]: SftpIPAccessRulesDialog,
   [DialogTypes.CreateSftpUser.id]: CreateSftpUserDialog,
   [DialogTypes.RenameSftpUserDialog.id]: RenameSftpUserDialog,
   [DialogTypes.DeleteSftpUserDialog.id]: DeleteSftpUserDialog,
   [DialogTypes.MoveSftpUserDialog.id]: MoveSftpUserDialog,
   // [DialogTypes.SearchSftpUserDialog.id]: SearchSftpUserDialog,

   [DialogTypes.CreateSftpGroup.id]: CreateSftpGroupDialog,
   [DialogTypes.DeleteSftpGroupDialog.id]: DeleteSftpGroupDialog,
   [DialogTypes.RenameSftpGroupDialog.id]: RenameSftpGroupDialog,
   [DialogTypes.MoveSftpGroupDialog.id]: MoveSftpGroupDialog,

   [DialogTypes.CreatePhysicalFolderDialog.id]: CreatePhysicalFolderDialog,
   [DialogTypes.CreateVirtualFolderDialog.id]: CreateVirtualFolderDialog,
   [DialogTypes.DeleteVFSNode.id]: DeleteVFSNodeDialog,

   [DialogTypes.SaveSynchronizationAsDialog.id]: SaveSynchronizationAsDialog,
   [DialogTypes.DeleteSynchronizationDialog.id]: DeleteSynchronizationDialog,
   [DialogTypes.CreateSynchronization.id]: CreateSynchronizationDialog,
   [DialogTypes.SearchSynchronizationDialog.id]: SearchSynchronizationDialog,
   [DialogTypes.MoveSynchronizationDialog.id]: MoveSynchronizationDialog,

   [DialogTypes.SearchSSHPublicKeysDialog.id]: SearchSSHPublicKeysDialog,

   [DialogTypes.CancelableConfirmationDialog.id]: CancelableConfirmationDialog,
   [DialogTypes.ConfirmDialog.id]: ConfirmDialog,
};

class CommonDialog extends React.PureComponent<DialogRoutesProps> {
   onClose = (name: string, result?: string, onClose?: (data?: any) => void) => (data?: any) => {
      // console.debug('Close dialog', name, result, data, onClose);
      const {
         location: {search},
         navigate,
         closeDialog,
      } = this.props;
      const parsedQuery = qs.parse(search);
      if (parsedQuery && parsedQuery.dialog === name) {
         delete parsedQuery.dialog;
         navigate({search: qs.stringify(parsedQuery)});
      } else {
         closeDialog(name, result, data);
      }
      onClose?.(data);
   };

   getDialog = (dialogName: string, options?: IDialogProps) => {
      const DialogComponent = dialogsMap[dialogName];
      if (DialogComponent) {
         return (
            <DialogComponent
               data={options?.data}
               onClose={this.onClose(
                  dialogName,
                  undefined,
                  options?.data?.onClose || options?.onClose
               )}
            />
         );
      }

      switch (dialogName) {
         case DialogTypes.SearchSSHClientKeysDialog.id:
            return (
               <SearchSSHClientKeysDialog
                  header={DialogTypes.SearchSSHClientKeysDialog.dialogName}
                  onClose={this.onClose(dialogName)}
               />
            );

         case DialogTypes.ImportSSLClientCertificate.id:
            return (
               <ImportSSLCertificateDialog
                  data={options?.data}
                  client
                  onClose={this.onClose(dialogName)}
               />
            );

         case DialogTypes.SearchSSLKeysDialog.id:
            return (
               <SearchSSLKeysDialog
                  header={DialogTypes.SearchSSLKeysDialog.dialogName}
                  onClose={this.onClose(dialogName)}
               />
            );

         case DialogTypes.MoveKeysDialog.id:
            return (
               <MoveKeysDialog
                  header={DialogTypes.MoveKeysDialog.dialogName}
                  onClose={this.onClose(dialogName)}
                  data={options?.data}
               />
            );
         case DialogTypes.CreateInternalPartner.id:
            return (
               <CreatePartnerDialog
                  header={DialogTypes.CreateInternalPartner.dialogName}
                  onClose={this.onClose(dialogName)}
                  objectType={DiplomatObjectType.enum.INTERNAL_PARTNER}
                  data={options?.data}
               />
            );
         case DialogTypes.CreateExternalPartner.id:
            return (
               <CreatePartnerDialog
                  header={DialogTypes.CreateExternalPartner.dialogName}
                  onClose={this.onClose(dialogName)}
                  objectType={DiplomatObjectType.enum.EXTERNAL_PARTNER}
                  data={options?.data}
               />
            );

         case DialogTypes.MovePartnerDialog.id:
            return (
               <MovePartnerDialog
                  header={DialogTypes.MovePartnerDialog.dialogName}
                  onClose={this.onClose(dialogName)}
                  data={options?.data}
               />
            );

         case DialogTypes.AuditWarningDialog.id:
            return <AuditWarningDialog onClose={this.onClose(dialogName)} />;

         case DialogTypes.SearchPartnerDialog.id:
            return (
               <SearchPartnerDialog
                  header={DialogTypes.SearchPartnerDialog.dialogName}
                  onClose={this.onClose(dialogName)}
               />
            );
         case DialogTypes.SearchOpenPGPKeysDialog.id:
            return (
               <SearchOpenPGPKeysDialog
                  header={DialogTypes.SearchOpenPGPKeysDialog.dialogName}
                  onClose={this.onClose(dialogName)}
               />
            );

         case DialogTypes.CreateInboundTransaction.id:
            return (
               <CreateTransactionDialog
                  header={DialogTypes.CreateInboundTransaction.dialogName}
                  onClose={this.onClose(dialogName)}
                  objectType={DiplomatObjectType.enum.INBOUND_TRANSACTION}
                  data={options?.data}
               />
            );
         case DialogTypes.CreateOutboundTransaction.id:
            return (
               <CreateTransactionDialog
                  header={DialogTypes.CreateOutboundTransaction.dialogName}
                  onClose={this.onClose(dialogName)}
                  objectType={DiplomatObjectType.enum.OUTBOUND_TRANSACTION}
                  data={options?.data}
               />
            );
         case DialogTypes.SearchTransactionsDialog.id:
            return (
               <SearchTransactionDialog
                  header={DialogTypes.SearchTransactionsDialog.dialogName}
                  onClose={this.onClose(dialogName)}
               />
            );

         case DialogTypes.MoveFolderDialog.id:
            return (
               <MoveFolderDialog
                  onClose={this.onClose(dialogName)}
                  data={options?.data}
                  header={DialogTypes.MoveFolderDialog.dialogName}
               />
            );

         case DialogTypes.AlertDialog.id:
            return (
               <AlertDialog
                  title={options?.title}
                  content={options?.content}
                  maxWidth={options?.maxWidth}
                  onClose={this.onClose(dialogName)}
               />
            );
         case DialogTypes.ConfirmationDialog.id:
            return (
               <ConfirmationDialog
                  title={options?.title}
                  content={options?.content}
                  onOk={this.onClose(dialogName, DialogResult.OK)}
                  onCancel={this.onClose(dialogName, DialogResult.CANCEL)}
               />
            );
      }
   };

   render() {
      const {
         location: {search},
         subDialogs,
      } = this.props;
      // console.debug(this.props);

      const parsedQuery = qs.parse(search);

      return (
         <div>
            <div>{this.getDialog(parsedQuery?.dialog as string)}</div>
            <div>
               {map(subDialogs, (d) => (
                  <div key={d.id}>{this.getDialog(d.id, d)}</div>
               ))}
            </div>
         </div>
      );
   }
}

export default CommonDialog;
